import type { ReactNode } from 'react';

export const symbol_volcano: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M800-80H172q-32 0-50.5-27t-4.5-57l107-240q8-17 22.55-26.5T279-440h81l65-162q7-17 22.08-27.5Q462.15-640 481-640h194q20.35 0 36.17 12Q727-616 732-596l126 440q8 29-10 52.5T800-80Zm-628-60h628L675-580H480l-72 181q-3.78 8.36-11.35 13.68T380-380H279L172-140Zm371-670v-80q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v80q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37Zm160 43 57-57q9-9 21-8.5t21 8.7q9 8.95 9 20.87 0 11.93-9 20.93l-57 57q-9 8-21.1 8.5-12.1.5-20.9-8.5-9-9-9-21t9-21Zm-302 42-57-57q-9-9-8.5-21t8.7-21q8.95-9 20.87-9 11.93 0 20.93 9l57 57q8 9 8.5 21.1.5 12.1-8.5 20.9-9 9-21 9t-21-9ZM172-140h628-628Z"
		/>
	</svg>
);
